import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import TextArea from 'antd/lib/input/TextArea';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import React, { useState, useEffect, useRef } from 'react';
import { IPAddress, TROUBLEREPORT } from '../../../commons/api';
import { DownloadOutlined, EditOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import {
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  Space,
  Tooltip,
  Upload,
  message
} from 'antd';
import {
  _getAttachmentList,
  _saveTroubleReport,
  getEditObject
} from '../Utils/ApICalls';

const ChatUpload = (props) => {
  const [attachments, setAttachments] = useState([]);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [fileList, setFileList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInputRef = useRef(null);

  useEffect(() => {
    getAttachmentList();
  }, []);

  const getAttachmentList = async () => {
    let attachments = await _getAttachmentList();
    setAttachments(attachments);
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };


  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation('Search')}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const getFormData = (inputData) => {
    _.cloneDeepWith(inputData, (value) => {
      return value && value !== undefined && value !== null
        ? {
          ...value,
          ...(value['TroubleTime'] && value['TroubleTime'] !== null
            ? (value['TroubleTime'] = moment.utc(value.TroubleTime, 'YYYY-MM-DD HH:mm:ss'))
            : null),
          ...(value['ActualStart'] && value['ActualStart'] !== null
            ? (value['ActualStart'] = moment.utc(value.ActualStart, 'YYYY-MM-DD HH:mm:ss'))
            : null),
          ...(value['ActualEnd'] && value['ActualEnd'] !== null
            ? (value['ActualEnd'] = moment.utc(value.ActualEnd, 'YYYY-MM-DD HH:mm:ss'))
            : null)
        }
        : _.noop();
    });
    setData(inputData);
  };

  const disabledDate = (currentDay) => {
    return currentDay > moment().endOf('day');
  };

  const renderForm = (columns, data) => {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    let { maxLength, disable, placeHolder, widget, key } = columns;

    switch (widget) {
      case 'input':
        return (
          <Input
            value={data && data[key] ? data[key] : ''}
            maxLength={maxLength ? maxLength : 100}
            disabled={disable ? disable : false}
            placeholder={placeHolder ? placeHolder : ''}
            onChange={(e) => setData((prevState) => ({
              ...prevState, [key]: e.target.value
            }))}
          />
        );
      case 'datePicker':
        return (
          <DatePicker
            value={data && data[key] && data[key] !== null ? moment(data[key]) : undefined}
            showNow={false}
            showTime
            format={dateFormat}
            disabledDate={disabledDate}
            placeholder={placeHolder ? placeHolder : ''}
            onChange={(e) => {
              data = { ...data, [key]: moment(e).format(dateFormat) };
              if (
                (key === 'ActualStart' || key === 'ActualEnd') &&
                data['ActualStart'] &&
                data['ActualEnd']
              ) {
                let TotalDowntime = moment(data['ActualEnd'], 'YYYY-MM-DD HH:mm').diff(
                  moment(data['ActualStart'], 'YYYY-MM-DD HH:mm'),
                  'minutes'
                );
                data = { ...data, TotalDowntime };
                setData(data);
              } else {
                setData(data);
              }
            }}
          />
        );
      case 'textArea':
        return (
          <TextArea
            value={data && data[key] ? data[key] : ''}
            rows={4}
            placeholder={placeHolder}
            onChange={(e) => setData((prevState) => ({
              ...prevState, [key]: e.target.value
            }))}
          />
        );

      default:
        return (
          <Input
            value={data && data[key] ? data[key] : ''}
            maxLength={maxLength ? maxLength : 100}
            disabled={disable ? disable : false}
            placeholder={placeHolder ? placeHolder : ''}
            onChange={(e) => setData((prevState) => ({
              ...prevState, [key]: e.target.value
            }))}
          />
        );
    }
  };

  const onSave = async (formObject) => {
    let checkRows = await checkAllMandatoryFields(formObject, data);
    if (checkRows === false) {
      let saveTroubleReport = await _saveTroubleReport(data, data.Id);
      if (saveTroubleReport && saveTroubleReport.message) {
        setOpen(false);
        setData({});
        getAttachmentList();
      }
    } else {
      message.error('Please enter mandatory fields');
    }
  };

  const checkAllMandatoryFields = (formObject, data) => {
    let checkRow = false;
    let allMandatoryList = formObject
      .filter((e) => e.required === true)
      .map((e) => {
        return e.key;
      });

    if (data && Object.keys(data) && Object.keys(data).length > 0) {
      allMandatoryList.map((fields) => {
        if (data[fields] && data[fields] !== '') {
          return {};
        } else {
          checkRow = true;
        }
        return {};
      });
    } else {
      checkRow = true;
    }
    return checkRow;
  };

  const onEdit = async (record) => {
    let editObject = await getEditObject(record.Id);
    if (editObject && editObject[0]) {
      setData(editObject[0]);
      setOpen(true);
    }
  };

  const columns = [
    {
      title: translation('Device Name'),
      dataIndex: 'DeviceName',
      key: 'DeviceName',
      ...getColumnSearchProps('DeviceName')
    },
    {
      title: translation('Trouble Time'),
      dataIndex: 'TroubleTime',
      key: 'TroubleTime',
      render: (text) => <>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : text}</>
    },
    {
      title: translation('Problem'),
      dataIndex: 'Problem',
      key: 'Problem',
      ...getColumnSearchProps('Problem')
    },
    {
      title: translation('Start Time'),
      dataIndex: 'ActualStart',
      key: 'ActualStart',
      render: (text) => <>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : text}</>
    },
    {
      title: translation('End TIme'),
      dataIndex: 'ActualEnd',
      key: 'ActualEnd',
      render: (text) => <>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : text}</>
    },
    {
      title: translation('Total Downtime(mins)'),
      dataIndex: 'TotalDowntime',
      key: 'TotalDowntime',
      ...getColumnSearchProps('TotalDowntime')
    },
    {
      title: translation('Power Generation Loss'),
      dataIndex: 'PowerGenerationLoss',
      key: 'PowerGenerationLoss',
      ...getColumnSearchProps('PowerGenerationLoss')
    },
    {
      title: translation('Sales Loss'),
      dataIndex: 'SalesLoss',
      key: 'SalesLoss',
      ...getColumnSearchProps('SalesLoss')
    },
    {
      title: translation('Prepared By'),
      dataIndex: 'PreparedBy',
      key: 'PreparedBy',
      ...getColumnSearchProps('PreparedBy')
    },
    {
      title: translation('Vector DB Status'),
      dataIndex: 'VectorDBStatus',
      key: 'VectorDBStatus',
      ...getColumnSearchProps('VectorDBStatus')
    },
    {
      title: translation('Actions'),
      dataIndex: 'Actions',
      key: 'Actions',
      render: (text, record) => (
        <>
          <Tooltip placement="top" key="download" title={translation('Download')}>
            <>
              <a
                href={`${IPAddress.LOCAL}${TROUBLEREPORT.Download}?Id=${record.Id}&SiteId=${siteId}`}
              >
                <DownloadOutlined/>
              </a>
            </>
          </Tooltip>
          <Tooltip placement="top" key="Edit" title={translation('Edit')}>
            <>
              <EditOutlined
                onClick={() => onEdit(record)}
                style={{
                  color: '#163046',
                  cursor: 'pointer',
                  marginLeft: '10px'
                }}
              />
            </>
          </Tooltip>
        </>
      )
    }
  ];
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const propss = {
    action:
      data && (!data.VectorDBStatus || data.VectorDBStatus !== 'Success')
        ? data && data.VectorDBStatus && data.VectorDBStatus === 'Error'
          ? `${TROUBLEREPORT.RetryVectorDB}?SiteId=${siteId}&Id=${data.Id}`
          : `${TROUBLEREPORT.UPLOAD}?SiteId=${siteId}`
        : '',
    headers: {
      Authorization: Authorization
    },
    onChange: (info) => {
      if (info.file.status === 'done') {
        message.success(info.file.response.message);
        if (data && data.Id) {
          onEdit(data);
        } else {
          let { data } = info.file.response;
          getFormData(data);
        }
      } else if (info.file.status === 'error') {
        message.error(info.file.response.message);
      }
      setFileList(info.fileList);
    }
  };
  const onClose = () => {
    getAttachmentList();
    setOpen(false);
    setData({});
    setFileList([]);
  };
  let formObject = [
    {
      title: translation('Device Name'),
      key: 'DeviceName',
      widget: 'input',
      placeHolder: translation('Input Device Name'),
      required: true
    },
    {
      title: translation('Device Description'),
      key: 'DeviceDescription',
      widget: 'input',
      placeHolder: translation('Input Device Description'),
      required: true
    },
    {
      title: translation('Trouble Time'),
      key: 'TroubleTime',
      widget: 'datePicker',
      placeHolder: translation('Input Trouble Time'),
      required: true
    },
    {
      title: translation('Start Time'),
      key: 'ActualStart',
      widget: 'datePicker',
      placeHolder: translation('Input Start Time'),
      required: true
    },
    {
      title: translation('End TIme'),
      key: 'ActualEnd',
      widget: 'datePicker',
      placeHolder: translation('Input End Time'),
      required: true
    },
    {
      title: translation('Total Downtime(mins)'),
      key: 'TotalDowntime',
      widget: 'input',
      placeHolder: translation('Input Total Downtime'),
      required: true
    },
    {
      title: translation('Problem'),
      key: 'Problem',
      widget: 'input',
      placeHolder: translation('Input Problem'),
      required: true
    },

    {
      title: translation('Summary'),
      key: 'Summary',
      widget: 'textArea',
      placeHolder: translation('Input Summary'),
      required: true
    },
    {
      title: translation('Cause'),
      key: 'Cause',
      widget: 'textArea',
      placeHolder: translation('Input Cause'),
      required: false
    },
    {
      title: translation('Remedy'),
      key: 'Remedy',
      widget: 'textArea',
      placeHolder: translation('Input Remedy'),
      required: false
    },
    {
      title: translation('Actions'),
      key: 'Actions',
      widget: 'textArea',
      placeHolder: translation('Input Actions'),
      required: false
    },
    {
      title: translation('Power Generation Loss'),
      key: 'PowerGenerationLoss',
      widget: 'input',
      placeHolder: translation('Input Power Generation Loss'),
      required: false
    },
    {
      title: translation('Sales Loss'),
      key: 'SalesLoss',
      widget: 'input',
      placeHolder: translation('Input Sales Loss'),
      required: false
    },
    {
      title: translation('Prepared By'),
      key: 'PreparedBy',
      widget: 'input',
      placeHolder: translation('Input Prepared By'),
      required: false
    }
  ];
  return (
    <>
      <div style={{ margin: '20px' }}>
        <Button typr="primary" onClick={() => setOpen(true)}>
          {translation('Add')}
        </Button>

        <Drawer
          title={
            data && data.Id
              ? translation('Update Trouble Report')
              : translation('Create Trouble Report')
          }
          placement={'bottom'}
          width={500}
          height={window.innerHeight - 135}
          onClose={onClose}
          open={open}
          extra={
            <Space>
              <Button onClick={onClose}>{translation('Cancel')}</Button>
              <Button type="primary" onClick={() => onSave(formObject)}>
                {translation(data && data.Id ? 'Update' : 'Save')}
              </Button>
            </Space>
          }
        >
          {data && data.Id ? (
            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
              {data.VectorDBStatus}{' '}
              <span style={{ fontWeight: 'bold' }}>
                {translation('Vector Database Upload')}:{' '}
              </span>
            </div>
          ) : null}
          {data && (!data.VectorDBStatus || data.VectorDBStatus !== 'Success') ? (
            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
              <Upload {...propss} fileList={fileList}>
                <Button  icon={<UploadOutlined />}>
                  {data && data.VectorDBStatus && data.VectorDBStatus === 'Error'
                    ? translation('Retry PDF Upload')
                    : translation('Upload PDF Document')}
                </Button>
              </Upload>
            </div>
          ) : null}

          <Form
            name="basic"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 14 }}
            layout="horizontal"
            autoComplete="off"
          >
            {formObject && Array.isArray(formObject)
              ? formObject.map((column, index) => {
                return (
                  <div key={index}>
                    <Form.Item required={column.required || false} label={column.title}>
                      {renderForm(column, data)}
                    </Form.Item>
                  </div>
                );
              })
              : null}
          </Form>
        </Drawer>
        <StyledTable size="small"
          className="TableWidget"
          style={{ marginTop: '20px' }}
          columns={columns ? columns : []}
          dataSource={attachments ? attachments : []}
          scroll={{ x: 1000, y: 1000 }}
        />
      </div>
    </>
  );
};


const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(ChatUpload);
